export default "__VITE_PUBLIC_ASSET__9f3187f2__"